import React, { useState } from 'react'
import { Modal, message } from 'antd';
import { DropzoneArea } from 'material-ui-dropzone';

import { url } from "../Constent/Constant";

const Header = ({ Heading, Image, UpdateText, GetData , UpdateImage }) => {
    const [HeadingUpdate, setHeadingUpdate] = useState('')
    const [TextModalVisible, setTextModalVisible] = useState(false);
    const [ImageUpdate, setImageUpdate] = useState(null)
    const [ImageModal, setImageModal] = useState(false);

    const ShowTextModal = () => {
        setTextModalVisible(true);
    };

    const showImageModal = () => {
        setImageModal(true);
    };


    const TextHandle = () => {
        if (HeadingUpdate === '') {
            message.error('Fill the Field')
        } else {
            UpdateText({
                text: HeadingUpdate,
                id: GetData.headingId
            })
            setTextModalVisible(false);
            setHeadingUpdate('')
        }
    };

    const OnImageHandle = () => {
        if (ImageUpdate === null) {
            message.error('Insert Image')
        } else {
            UpdateImage({
                image: ImageUpdate,
                id: GetData.imgId
            })
            setImageModal(false);
        }
    };

    const handleCancel = () => {
        setTextModalVisible(false);
        setImageModal(false);
    };


    return (
        <div className='Header'>
            <i onClick={showImageModal} className="far fa-edit Edit-btn"></i>
            <div>
            </div>
            {Image === 'No Image' ? 'No Image' : <img src={`${url}/api/getFile${Image}`} alt='Header' />}
            
            {Heading ? (
                <h1>{Heading}
                <i onClick={ShowTextModal} className="far fa-edit Heading-edit"></i>
            </h1>
            ) : ''}

            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '30%' }} title='Update Heading' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
                <input value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
            </Modal>

            {/* Update Image Modal */}
            <Modal width={700} style={{ top: '5%' }} title='Update Text' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
                <DropzoneArea
                    filesLimit={1}
                    acceptedFiles={['image/*']}
                    dropzoneText={"Update Product Images"}
                    onChange={(files) => {
                        console.log('Files:', files[0])
                        setImageUpdate(files[0])
                    }}
                />
            </Modal>
        </div>
    )
}

export default Header
